export class SimpleRepairsUpdatesCommentsPostRequest {
  comment!: string
}
